import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import StrategyMapEditor from "./pages/StrategyMapEditor";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<StrategyMapEditor />} />
      </Routes>
    </Router>
  );
}
